const situacaoAluno = {
    cancelado: 1139,
    matriculado: 1138,
    aprovado: 1140,
    reprovado: 1141,
    reprovadoFrequencia: 1609,
    trancamento: 1611,
  }

  export default situacaoAluno
